// CustomHelpButton.js - A minimal component to work with CSS styles
import React from 'react';

const CustomHelpButton = ({ onClick }) => {
  // Using a minimal approach since the CSS is overriding styles with !important
  return (
    <button
      className="custom-help-button"
      onClick={onClick}
      aria-label="Tour Guide"
    >
      ?
      <div className="tooltip">
        Tour Guide
      </div>
    </button>
  );
};

export default CustomHelpButton;